export function getSecureGWTToken() {
  const regexp = /_data=([^&#?]*)/;
  const element = document.querySelector('a#baseurl');
  const baseurl = element.getAttribute('href');
  const urlValues = regexp.exec(baseurl);
  if (!urlValues || urlValues.length === 0) {
    throw new Error('Secure GWT token element not found');
  }
  return urlValues[1];
}

export function getSecureGWTQueryParam() {
  return `_data=${getSecureGWTToken()}`;
}
